export default {"src":"/_next/static/media/lightning_protection_logo.dcac54ff.svg","height":83,"width":223,"blurWidth":0,"blurHeight":0};